import { EMPTY, Observable, iif, of } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';

import { RequestRoot } from 'types';
import { Command, CommandContext, CommandPage } from 'controls';
import { NotificationService } from '../service/notification-service';

export class DeleteCommand implements Command<RequestRoot> {
    constructor(
        private _caption: string,
        private notificationService: NotificationService
    ) {}

    icon(): string {
        return 'delete-24px';
    }

    caption(): string {
        return this._caption;
    }

    color(): boolean {
        return true;
    }

    visible(
        ctx: CommandContext,
        selection: RequestRoot[],
        all: RequestRoot[]
    ): boolean {
        return true;
    }

    enabled(ctx: CommandContext, selection: RequestRoot[]): boolean {
        return selection.length !== 0;
    }

    execute(
        ctx: CommandContext,
        page: CommandPage,
        requests: RequestRoot[]
    ): Observable<RequestRoot> {
        return of(requests).pipe(
            concatMap((x) =>
                ctx.confirmRequestsAction(
                    page,
                    x,
                    'confirmation.mobile.delete.requests',
                    true
                )
            ),
            concatMap((x) =>
                iif(
                    () => Boolean(x?.id),
                    this.notificationService
                        .deleteStatusChangesForRequest(x.id!)
                        .pipe(map(() => x)),
                    EMPTY
                )
            ),
            concatMap((x) => ctx.wipeRequest(page, x))
        );
    }
}
